import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 20 20">
    <path fill="currentColor" d="M10 -3.05176e-05C15.5228 -3.05176e-05 20 4.47712 20 9.99997C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 9.99997C0 4.47712 4.47715 -3.05176e-05 10 -3.05176e-05ZM7.05279 6.58538C7.01807 6.65481 7 6.73136 7 6.80899V13.191C7 13.4671 7.22386 13.691 7.5 13.691C7.57762 13.691 7.65418 13.6729 7.72361 13.6382L14.1056 10.4472C14.3526 10.3237 14.4527 10.0234 14.3292 9.77637C14.2808 9.67957 14.2023 9.60117 14.1056 9.55277L7.72361 6.36177C7.47662 6.23828 7.17628 6.33839 7.05279 6.58538Z"/>
  </SvgIcon>
);